import UserService from './UserService'
import AdminService from './AdminService'
import MessageService from './MessageService'


export default class Api {
    constructor() {
        this.userService = new UserService(this)
        this.adminService = new AdminService(this)
        this.messageService = new MessageService(this)
    }

    /**
     * Api request
     * @param {String} method
     * @param {string} url
     * @param {Object<any>} params
     * @param {Boolean} downloadFile
     */
    request(method, url, params, downloadFile = false) {
        return new Promise((resolve, reject) => {
            const isFormData = params instanceof FormData
            const options = {
                method: method,
                headers: { 'Content-Type': 'application/json', },
                body: method === "GET" ? null : params ? (typeof params === 'string' || isFormData ? params : JSON.stringify(params)) : null
            }
            if (isFormData) delete options.headers

            if (params !== null && method === "GET") {
                for (const [key, value] of Object.entries(params)) {
                    url = value === "" ? url : url.indexOf('?') > -1 ? `${url}&${key}=${value}` : `${url}?${key}=${value}`
                }
            }

            return fetch(url, options).then((response) => {
                if (response.status >= 200 && response.status <= 299) {
                    if (downloadFile) return response.blob()
                    return response.json()
                } else {
                    reject(response)
                }
            }).then((response) => {
                resolve(response)
            }).catch((error) => {
                reject(error)
            })
        })
    }
}